<template>
  <div>
    <ui-button
      class="integration-button"
      :color="isEnabled ? 'default' : 'primary'"
      @click="
        hasNoAccounts
          ? (showAccountsAlertDialog = true)
          : (showToggleDialog = true)
      "
    >
      <span v-if="isEnabled">{{ $t("message.mapIntegrations.disable") }}</span>
      <span v-else>{{ $t("message.mapIntegrations.enable") }}</span>
    </ui-button>
    <AppleNoAccountDialog
      v-if="showAccountsAlertDialog"
      @close="showAccountsAlertDialog = false"
    />
    <AppleToggleDialog
      v-if="showToggleDialog"
      :title="title"
      :description="description"
      @confirm="toggleIntegration"
      @close="showToggleDialog = false"
    />
  </div>
</template>

<script>
import mapIntegrationsService from "@/services/mapIntegrations.js";
import serviceHandler from "@/helpers/handlers/service";
export default {
  name: "ToggleAppleIntegrationButton",
  props: {
    isEnabled: {
      type: Boolean,
      default: false
    },
    hasNoAccounts: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AppleNoAccountDialog: () =>
      import("@/components/BusinessAddresses/AppleNoAccountDialog.vue"),
    AppleToggleDialog: () =>
      import("@/components/BusinessAddresses/AppleToggleDialog.vue")
  },

  data() {
    return {
      showAccountsAlertDialog: false,
      showToggleDialog: false
    };
  },

  computed: {
    title() {
      return this.isEnabled
        ? this.$t("message.apple.disableDialog.title")
        : this.$t("message.apple.enableDialog.title");
    },
    description() {
      return this.isEnabled
        ? this.$t("message.apple.disableDialog.description")
        : this.$t("message.apple.enableDialog.description");
    }
  },

  methods: {
    async toggleIntegration() {
      try {
        this.isLoading = true;
        const payload = {
          apple: {
            is_enabled: !this.isEnabled
          }
        };
        await serviceHandler(
          mapIntegrationsService.toggleMapIntegration(payload)
        );

        this.$emit("get-integrations");
      } finally {
        this.isLoading = false;
        this.showToggleDialog = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.integration-button {
  max-width: 150px;
  ::v-deep .v-btn__content {
    display: flex;
    align-items: center;
    gap: $spacing;
    width: 100%;

    svg {
      flex-shrink: 0;
    }

    span {
      white-space: break-spaces;
      text-align: left;
    }
  }
}
</style>
